// authNotice — a one-shot message for the login page ("Your session expired…").
//
// A toast shown just before `window.location.assign('/login')` dies with the
// page. The caller stores the notice in sessionStorage AFTER logout (which
// clears sessionStorage) and LoginPage shows it once.
export const AUTH_NOTICE_KEY = 'authNotice';

export const setAuthNotice = (message, session = window.sessionStorage) => {
  try { session.setItem(AUTH_NOTICE_KEY, message); } catch { /* storage unavailable */ }
};

export const peekAuthNotice = (session = window.sessionStorage) => {
  try { return session.getItem(AUTH_NOTICE_KEY) || null; } catch { return null; }
};

export const clearAuthNotice = (session = window.sessionStorage) => {
  try { session.removeItem(AUTH_NOTICE_KEY); } catch { /* storage unavailable */ }
};
